export function computeEventDashboardStats(event, statistics) {
  if (!event || !statistics) return null;

  if (event.corporate) {
    let sent = 0;
    let accepted = 0;
    let pending = 0;
    let rejected = 0;
    let remaining = 0;

    (event.categories || []).forEach((cat) => {
      const s = statistics[cat.category] || {};
      const p = s.pendingInvitations || 0;
      const a = s.acceptedInvitations || 0;
      const r = s.rejectedInvitations || 0;
      sent += p + a + r;
      accepted += a;
      pending += p;
      rejected += r;
      remaining += s.remaining || 0;
    });

    const responded = accepted + rejected;
    const responseRate = sent > 0 ? Math.round((responded / sent) * 100) : 0;
    const confirmRate = sent > 0 ? Math.round((accepted / sent) * 100) : 0;

    return {
      mode: "corporate",
      sent,
      accepted,
      pending,
      rejected,
      remaining,
      inventory: sent + remaining,
      responseRate,
      confirmRate,
    };
  }

  let sold = 0;
  let remaining = 0;
  (event.categories || []).forEach((cat) => {
    const s = statistics[cat.category] || {};
    sold += s.sold || 0;
    remaining += s.remaining || 0;
  });

  const total = sold + remaining;
  const sellThrough = total > 0 ? Math.round((sold / total) * 100) : 0;

  return {
    mode: "ticketing",
    sold,
    remaining,
    total,
    sellThrough,
  };
}
